<template>
    <Mz-Dialog class="dialog" :title="title" width="6000px" :visible.sync="visible" @handleClose="handleClose">
        <div slot="content" class="flx-bs main" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0,0,0,0)">
            <div class="part">
                <h3>{{data.international.title}}</h3>
                <div class="chart" id="inter"></div>
                <p>{{data.international.tips}}</p>
                <p>来源：<span>{{data.international.source}}</span></p>
            </div>
            <div class="part">
                <h3>{{data.china.title}}</h3>
                <div class="chart" id="china"></div>
                <p>{{data.china.tips}}</p>
                <p>来源：<span>{{data.china.source}}</span></p>
            </div>
            <div class="flx-bs part">
                <div class="box">
                    <div class="title">{{data.wayArea.title}}</div>
                    <div class="area" id="area"></div>
                </div>
                <div class="box">
                    <div class="title">{{data.ways.title}}</div>
                    <div class="area" id="way"></div>
                </div>
            </div>
            <div class="part">
                <!-- <h3>天然食材</h3> -->
                <img :src="data.trsc" style="width:100%">
            </div>
        </div>
    </Mz-Dialog>
</template>

<script>
import echarts from 'echarts'
import 'echarts/map/js/china'
    export default {
        components: {},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: {}
            },
            title: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                loading: false,
            }
        },
        created() {
        },
        mounted() {
            this.$nextTick(() => {
                this.echartsInter('inter')
                this.echartsInter('china')
                this.echartsWay()
                this.echartsWay2()
            })
        },
        methods: {
            echartsInter(type){
                let that = this
                var chart = null
                let datas = []
                let dataX = []
                let names = []
                let chartData = []
                if(type==='inter'){
                    chart = echarts.init(document.getElementById('inter'));
                    chartData = this.data.international.datas
                }else{
                    chart = echarts.init(document.getElementById('china'));
                    chartData = this.data.china.datas
                }
                dataX = chartData[0].data.map(it => it.name)
                names = chartData.map(it => it.name)
                chartData.forEach(item => {
                    let data = item.data.map(it => it.value)
                    datas.push({
                        data: data,
                        name: item.name,
                        type: 'bar',
                        barWidth: 30,
                        label: {
                            show: true,                    // 显示标签
                            position: 'top',               // 标签显示在柱子顶部
                            fontSize: 30,
                            color: '#fff',                 // 数值颜色
                            fontWeight: 'bold',
                            // 可选：格式化显示内容
                            formatter: '{c}',// {c} 表示数值，{a}系列名，{b}类目名
                        },
                    })
                });
                // 清空图表
                chart.clear();
                chart.setOption({
                    // 设置绘图区域的边距
                    grid: {
                        left: 0,   // 左侧距离
                        right: 200,  // 右侧距离
                        top: 100,   // 可选：顶部距离
                        bottom: 0, // 可选：底部距离
                        containLabel: true // 确保标签不被裁剪
                    },
                    legend: {
                        data: names,
                        textStyle: {
                            fontSize: 36,
                            color: '#fff',
                            padding:[0,10]
                        },
                        icon: 'circle',
                        itemGap: 27
                    },
                    color: ['#FFBE0C','#A20CFF','#1CFF0C','#AECDFF','#FF510C','#0C85FF'],
                    xAxis: {
                        type: 'category',
                        data: dataX,
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                            color: '#435D8C', // 设置 x 轴线的颜色
                            }
                        },
                        boundaryGap: false, // 去掉左右两边的空白
                        axisLabel: {
                            color: '#fff', // 文字颜色
                            fontSize: 30,   // 字体大小
                            margin: 24,
                            rotate: type=='china'?45:0
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: { show: false },
                        splitLine: { 
                            lineStyle: {
                                color: '#435D8C', // 设置 x 轴线的颜色
                            } 
                        },
                        axisTick: { show: false },
                        axisLabel: {
                            color: '#fff', // 文字颜色
                            fontSize: 28,   // 字体大小
                            margin: 100,
                            formatter: '{value}%'
                        }
                    },
                    series: datas,
                })
            },
            echartsWay(){
                let that = this
                var chart = echarts.init(document.getElementById('area'));
                // 清空图表
                chart.clear();
                var option = {
                    // 设置绘图区域的边距
                    grid: {
                        left: '20%',   // 左侧距离
                        right: '20%',  // 右侧距离
                        top: '20%',   // 可选：顶部距离
                        bottom: 0, // 可选：底部距离
                        containLabel: true // 确保标签不被裁剪
                    },
                    color: ['#008C5A','#0444A8'],
                    series: [
                        {
                            type: 'pie',
                            radius: ['50%', '70%'], // 内半径50%，外半径70%
                            avoidLabelOverlap: false,
                            label: {
                                show: true,
                                position: 'outside',
                                fontSize: 36,
                                fontWeight: 'bold',
                                color: '#fff',
                                formatter: '{b} {d}%'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: 42,
                                    fontWeight: 'bold',
                                    color: '#fff'
                                }
                            },
                            labelLine: {
                                show: true
                            },
                            data: that.data.wayArea.data
                        }
                    ]
                };

                // 使用刚指定的配置项和数据显示图表。
                chart.setOption(option);
            },
            echartsWay2(){
                let that = this
                var chart = echarts.init(document.getElementById('way'));
                let names = this.data.ways.data.map(it => it.name)
                let dataX = this.data.ways.data[0].data.map(it => it.name)
                let datas = []
                this.data.ways.data.forEach(item => {
                    let data = item.data.map(it => it.value)
                    datas.unshift({
                        data: data,
                        name: item.name,
                        type: 'bar',
                        label: {
                            show: true,                    // 显示标签
                            position: 'top',               // 标签显示在柱子顶部
                            fontSize: 36,
                            color: '#fff',                 // 数值颜色
                            fontWeight: 'bold',
                            // 可选：格式化显示内容
                            formatter: '{c}%',// {c} 表示数值，{a}系列名，{b}类目名
                        },
                    })
                })
                // 清空图表
                chart.clear();
                // 指定图表的配置项和数据
                var option = {
                    legend: {
                        data: names,
                        top: 70,
                        right: 70,
                        textStyle: {
                            fontSize: 36,
                            color: '#fff',
                            padding:[0,10]
                        },
                        itemGap: 27
                    },
                    color: ['#008C5A','#0444A8'],
                    grid: {
                        left: '3%',
                        right: '4%',
                        top: '10%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        boundaryGap: [0, 0.01],
                        axisLine: { show: false },
                        splitLine: { show: false},
                        axisTick: { show: false },
                    },
                    yAxis: {
                        type: 'category',
                        data: dataX,
                        axisLabel: {
                            interval: 0,
                            
                            color: '#fff', // 文字颜色
                            fontSize: 36,   // 字体大小
                        },
                        axisLine: { show: false },
                        splitLine: { show: false},
                        axisTick: { show: false },
                    },
                    series: datas
                };

                // 使用刚指定的配置项和数据显示图表。
                chart.setOption(option);
            },
            handleClose(){
                this.$emit('update:visible', false)
            }
        }
    }
</script>

<style lang="less" scoped>
@import '@/styles/common';
.main{
    padding: 40px;
}
.part{
    width: 49%;
    margin-bottom: 100px;
    background: rgba(0,0,0,.2);
    padding: 100px;
    h3{
        text-align: center;
        font-weight: bold;
        font-size: 42px;
        margin-bottom: 50px
    }
}
.chart{
    width: 100%;
    height: 1500px;
    margin-bottom: 50px;
}
.box{
    width: 50%;
    .area{
        width: 100%;
        height: 1500px;
    }
    .title{
        text-align: center;
        font-size: 42px;
        font-weight: bold;
    }
    .area2{
        width: 100%;
        height: 800px;
    }
}
</style>